define('lq/cssutil',['require', 'lq/cache'], function (require, Cache) {
	'use strict';

	var styleSheetCache = new Cache();

    return {
    	requireCss: function (path) {
    		this.loadCss(require.toUrl(path));
    	},

    	loadCss: function (url) {
    		if (styleSheetCache.has(url)) {
    			return;
    		}
    		styleSheetCache.set(url, true);

            var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = url;
            document.getElementsByTagName("head")[0].appendChild(link);
        }
    };
});

